import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedInUser } from './mockFullLoggedInUser';

export const mockFullLoggedInUserNoBadgesOneCourse: MockResponseConfig = {
  ...mockFullLoggedInUser,
  ProfileBadgesQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          aaid: '62587f99fdb60b0069294184',
          learning: {
            __typename: 'UnifiedLearning',
            id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184',
            recentCoursesBadges: {
              __typename: 'UnifiedProfileBadgesConnection',
              edges: [
                {
                  cursor: '0',
                  node: {
                    actionUrl: 'https://www.atlassian.com',
                    imageUrl: 'https://randomuser.me/api/portraits/men/6.jpg',
                    name: 'Test Course Four',
                    id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses/1',
                  },
                },
              ],
              totalCount: 1,
            },
          },
          badges: {
            __typename: 'UnifiedProfileBadgesConnection',
            edges: [],
            pageInfo: {
              endCursor: '0',
              hasNextPage: false,
              hasPreviousPage: false,
              startCursor: '0',
            },
            totalCount: 0,
          },
        },
      },
    },
  }),
};
